import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Modal, PrimaryButton, SecondaryButton } from '../../components';

import css from './MultiVendorCheckoutModal.module.css';

/**
 * Modal to inform users about multi-vendor checkout process
 * 
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {Function} props.onClose - Function to close the modal
 * @param {Function} props.onProceed - Function to proceed with checkout
 * @param {number} props.vendorCount - Number of vendors in the cart
 */
const MultiVendorCheckoutModal = ({ isOpen, onClose, onProceed, vendorCount }) => {
  return (
    <Modal
      id="MultiVendorCheckoutModal"
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={() => {}}
      containerClassName={css.modalContainer}
      closeButtonMessage="Fermer"
    >
      <div className={css.modalContent}>
        <h2 className={css.modalTitle}>
          <FormattedMessage id="MultiVendorCheckoutModal.title" />
        </h2>
        
        <div className={css.modalBody}>
          <div className={css.infoBox}>
            <div className={css.infoIcon}>ℹ️</div>
            <div className={css.infoText}>
              <FormattedMessage 
                id="MultiVendorCheckoutModal.message" 
                values={{ count: vendorCount }}
              />
            </div>
          </div>
          
          <div className={css.details}>
            <p className={css.detailsText}>
              <FormattedMessage id="MultiVendorCheckoutModal.explanation" />
            </p>
            <ul className={css.detailsList}>
              <li>
                <FormattedMessage 
                  id="MultiVendorCheckoutModal.detail1" 
                  values={{ count: vendorCount }}
                />
              </li>
              <li>
                <FormattedMessage id="MultiVendorCheckoutModal.detail2" />
              </li>
              <li>
                <FormattedMessage id="MultiVendorCheckoutModal.detail3" />
              </li>
            </ul>
          </div>
        </div>
        
        <div className={css.modalActions}>
          <SecondaryButton onClick={onClose} className={css.cancelButton}>
            <FormattedMessage id="MultiVendorCheckoutModal.cancel" />
          </SecondaryButton>
          <PrimaryButton onClick={onProceed} className={css.proceedButton}>
            <FormattedMessage id="MultiVendorCheckoutModal.proceed" />
          </PrimaryButton>
        </div>
      </div>
    </Modal>
  );
};

export default MultiVendorCheckoutModal;

